<template>
  <div class="wrapper">
    <span class="label">{{ label }}</span>
    <a
      v-if="href"
      :href="href"
      target="_blank"
    >{{ value }}</a>
    <span
      v-else
      class="value"
    >{{ value }}</span>
  </div>
</template>
<script>
  export default {
    props: {
      label: { type: String, default: "" },
      value: { type: [String, Boolean], default: "" },
      href: { type: String, default: "" },
    }
  };
</script>
<style lang="scss">
  .wrapper {
    display: flex !important;
    flex-direction: column;

    .label {
      font-size: 12px;
      line-height: 16px;
      color: #999;
    }
  }
</style>
